export default __webpack_public_path__ + "static/media/car_full.105b39fa.png";